import type { Language } from '~/types'

/**
 * Maps a UI language to an API language.
 * @param language - The UI language to map.
 * @returns The API language.
 */
export const mapToApiLanguage = (language: Language): App.Internals.Enums.Language => {
  switch (language) {
    case 'en-GB':
      return 'en'
    default:
      return language
  }
}

/**
 * Maps an API language to a UI language.
 * @param language - The API language to map. Can be an App.Internals.Enums.Language or 'en-GB' as in some cases these might be mixed.
 * @returns The UI language.
 */
export const mapToUiLanguage = (language: App.Internals.Enums.Language | 'en-GB'): Language => {
  switch (language) {
    case 'en':
      return 'en-GB'
    default:
      return language
  }
}
